/**
 * W1-11b (app-shell-ui): the browser entry point. Loads the design-system styles and fonts, then starts the app
 * (src/app/shell/bootstrap.tsx): settings load, services (src/app/services.ts, W1-16), keyboard router and focus
 * regions, registry attachment, i18n and preferences, the React root and its error boundaries.
 */

import './ui/styles/tokens.css';
import './ui/styles/themes.css';
import './ui/styles/global.css';
import { services } from './app/services';
import { keymap } from './app/registry/keymap';
import { layoutLabels } from './app/registry/layoutLabels';
import { registry } from './app/registry/registry';
import { settings } from './app/settings/settingsService';
import { bootstrap } from './app/shell/bootstrap';
import { focusRegions } from './app/shell/FocusRegions';
import { installKeyboardRouter } from './app/shell/KeyboardRouter';

const rootElement = document.getElementById('root');
if (rootElement === null) throw new Error('index.html is missing #root');

// Dev builds only: the end-to-end suite (test/e2e/support/app.ts) reaches this page's live services through this
// hook. Importing '/src/app/services.ts' from a test would not do: after a hot update the dev server serves the app
// a timestamped copy of the module, and a bare import would get a second, empty instance. `labels` is the keyboard
// layout label source (W3-01 fallbacks e2e: 'layoutMap' with the Keyboard API, 'fallback' without it).
if (import.meta.env.DEV) {
  Object.defineProperty(window, '__phiedit', {
    value: { services: () => services, labels: () => layoutLabels },
    configurable: true,
  });
}

bootstrap({
  root: rootElement,
  services: () => services,
  registry,
  keymap,
  settings,
  labels: layoutLabels,
  focusRegions,
  installRouter: installKeyboardRouter,
});
